import React, { memo } from "react";

import propTypes from "prop-types";
import cx from "classnames";
import { get, isEmpty, noop } from "lodash";

import { ICONS } from "../../constants/icons.constants";
import Icons from "../../components/icons";
import ThumbNail from "../../components/thumbNail";
import Button from "../../components/button";
import { BUTTON_TYPES } from "../../components/button/Button";
import { songActions } from "../../actions";
import ignoredSongStore from "../../zustand/ignoreSong.store";
import favoriteSongStore from "../../zustand/favoriteSong.store";

import styles from "./songItem.module.scss";
import userStore from "../../zustand/user.store";

const PlayListSongItem = ({
  song,
  isEditMode,
  handleRemove,
  handleItemClick,
}) => {
  const { id, title, thumbnail_img } = song;
  const { userOffline } = userStore((state) => ({
    userOffline: state.userOffline,
  }));

  const { songs: ignoredSongs, setIgnoreToSong } = ignoredSongStore(
    (state) => ({
      songs: state.songs,
      setIgnoreToSong: state.setIgnoreToSong,
    })
  );
  const { songs: favoriteSong, setFavouriteToSong } = favoriteSongStore(
    (state) => ({
      songs: state.songs,
      setFavouriteToSong: state.setFavouriteToSong,
    })
  );

  //! need to check
  const handleLikeClick = async (e) => {
    e.stopPropagation();
    setFavouriteToSong(id);

    const isSuccess = await songActions.addFavouriteToSong(id, userOffline);

    if (!isSuccess) {
      setFavouriteToSong(id);
      return;
    }
  };

  const handleIgnore = async (e) => {
    e.stopPropagation();

    setIgnoreToSong(id);

    const isSuccess = await songActions.addReactionToSong(
      id,
      "IGNORE",
      userOffline
    );
    if (!isSuccess) {
      setIgnoreToSong(id);
    }
  };

  return (
    <div className={styles.container} onClick={handleItemClick}>
      <div className={styles.img}>
        <ThumbNail
          name={title}
          className={styles.imgThumb}
          hasImage={!isEmpty(thumbnail_img)}
          imgSrc={thumbnail_img}
        />
      </div>

      <div className={styles.extraInfo}>
        <p className={styles.text1}>{title}</p>
      </div>

      <div className={styles.box}>
        {!isEditMode ? (
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              width: "160px",
            }}
            className={styles.scheduleInfo}
          >
            <div
              onClick={handleLikeClick}
              className={cx({ [styles.likedIcon]: favoriteSong?.[id] })}
              style={{ marginRight: "20px" }}
            >
              <Icons type={ICONS.LIKE_SONG_LIST} />
            </div>
            <div
              onClick={handleIgnore}
              className={cx({
                [styles.likedIcon]: get(ignoredSongs, id, false),
              })}
            >
              <Icons type={ICONS.IGNORE_SONG} />
            </div>
          </div>
        ) : (
          <div className={styles.removeBtn}>
            <Button
              type={BUTTON_TYPES.SECONDARY}
              onClick={(e) => {
                e.stopPropagation();
                handleRemove(id);
              }}
            >
              Remove
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

PlayListSongItem.propTypes = {
  normalView: propTypes.bool,
  removeView: propTypes.bool,
  dropdownView: propTypes.bool,
  scheduleListView: propTypes.bool,
  songName: propTypes.string,
  artistName: propTypes.string,
  scheduleName: propTypes.string,
  totalHours: propTypes.string,
  days: propTypes.array,
  id: propTypes.string,
  removeSong: propTypes.func,
  playListView: propTypes.bool,
  setSelectedPlaylist: propTypes.func,
  dropdownDaysView: propTypes.bool,
  setIsStateChanged: propTypes.func,
};

PlayListSongItem.defaultProps = {
  dropdownDaysView: false,
  normalView: false,
  setSelectedPlaylist: noop,
  removeView: false,
  dropdownView: false,
  playListView: false,
  scheduleListView: false,
  songName: "",
  artistName: "",
  scheduleName: "",
  totalHours: "",
  days: [],
  id: "",
  removeSong: noop,
  setIsStateChanged: noop,
};

export default memo(PlayListSongItem);
